import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AbstractDynamicComponent } from '@components/abstracts';
import { FilterToggleGroupComponent } from '@shared/components/filter-toggle-group';
import { GridSkeletonComponent } from '@shared/components/grid-skeleton';
import { Image } from '@shared/components/image/models';
import { OptionCardComponent } from '@shared/components/option-card';
import { PopinImageComponent } from '@shared/components/popin-image';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { FurnitureListing, LabelKey } from '@shared/models';
import { DialogService } from '@shared/services/dialog';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { LogsService } from '@shared/services/logs';
import { UrlParamsService } from '@shared/services/url-params';
import { filter, switchMap, take } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-listing-meubles-image-nom',
  templateUrl: './listing-meubles-image-nom.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FilterToggleGroupComponent, GridSkeletonComponent, OptionCardComponent, SvgComponent, TitleComponent],
})
export class ListingMeublesImageNomComponent extends AbstractDynamicComponent<FurnitureListing> implements OnInit {
  protected readonly filterName = 'filter_categorie_meuble';
  protected readonly filters = signal<LabelKey[]>(null!);
  private readonly filtersUrlParam = inject(UrlParamsService).param(this.filterName);
  private readonly dialogService = inject(DialogService);
  private readonly elasticSearchService = inject(ElasticSearchService);
  private readonly logs = inject(LogsService);
  protected readonly furnitures = toSignal(
    toObservable(this.filtersUrlParam).pipe(
      filter((param): param is string => !!param),
      switchMap((param) => this.elasticSearchService.getFurnituresImageName(this.data.productType, param.split('__')))
    )
  );

  ngOnInit() {
    const productType = this.data.productType;
    this.elasticSearchService
      .getFurnituresImageNameFilter(productType)
      .pipe(
        take(1),
        tap((filters) => this.filters.set(filters))
      )
      .subscribe({
        error: (err) => this.logs.error('ListingMeublesImageNomComponent', 'getFurnituresImageNameFilter failed', err),
      });
  }

  openVisualFullScreenModal(image: Image): void {
    this.dialogService.openDialog(PopinImageComponent, 'FULL_SCREEN', {
      data: {
        image,
      },
    });
  }
}
